export default __webpack_public_path__ + "static/media/dowload-file-template-voucher.10631381.xlsx";